import {FilterStateItem} from '../services/filter-recipients';
import {ResidentRoleType} from './data.types';

const recipientMailingListType = {
    owner_off: 'Owner Off-Site',
    owner_on: 'Owner On-Site',
    rent: 'Tenant',
    occupant: 'Occupant',
    resident: 'Resident',
    offsite_resident: 'Offsite Resident',
    guest: 'Guest',
    resident_owner: 'Resident Owner',
    resident_only_not_on_deed: 'Resident Only Not On Deed',
    owner_family: 'Owner Family',
    unknown: 'Not Set',
    unit_manager: 'Unit Manager',
    staff: 'Staff',
};

export type EmailStatusType =
    'pending' |
    'in_progress' |
    'completed' |
    'draft' |
    'scheduled';

export interface EmailRecipient {
    bdId: number;
    name?: string;
    email: string;
    type: ResidentRoleType;
    mobilePhone?: string;
    homePhone?: string;
    businessPhone?: string;
    buildingId?: number;
    buildingName?: string;
    buildingAddress?: string;
    suiteId?: number;
    suiteName?: string;
    emailMessage?: number; // Email Message Id
    status: EmailStatusType;
}

export interface EmailAttachment {
    name: string;
    path?: string;
    fileSize?: number;
    emailMessage?: number; // Email Message Id
}

export interface EmailData {
    sender: string;
    senderName: string;
    replyTo: string;
    replyToName: string;
    subject: string;
    message: string;
    sendMeCopy?: 0 | 1;
    filters?: string;
    recipientsFilter?: string;
    draft?: string;
    pmName: string;
    pmEmail?: string;
    pmMobilePhone?: string;
    pmCompanyId?: number;
    buildingId?: number | number[];
    buildingName?: string;
    buildingAddress?: string;
    scheduleDate?: string;
    status?: EmailStatusType;
    recipients?: Array<EmailRecipient>;
    recipientsChunk?: Array<EmailRecipient>;
    attachments: Array<EmailAttachment>;
}

export class Email implements EmailData {
    constructor(
        public id:               string = '',
        public sender:           string = '',
        public subject:          string = '',
        public replyTo:          string = '',
        public replyToName:      string = '',
        public senderName:       string = '',
        public message:          string = '',
        public pmName:           string = '',
        public pmEmail:          string = '',
        public pmMobilePhone:    string = '',
        public buildingName:     string = '',
        public buildingAddress:  string = '',
        public buildingId:       Array<number> = [],
        public sendMeCopy:       0 | 1 = 0,
        public status:           EmailStatusType = 'draft',
        public filtersList:      Array<FilterStateItem> = [],
        public recipientsFilter: string = '',
        public attachments:      Array<Attachment> = [],
        public recipients:       Array<any> = [],
        public createdAt:        string = '',
        public recipientsCount:  number = 0,
        public sentCount:        number = 0,
        public errorCount:       number = 0,
        public openedCount:      number = 0,
        public clickedCount:     number = 0,
        public scheduleDate:     string = '',
        public isCanEdit:        boolean = false,
        public isCanDelete:      boolean = false

    ) {}

    get filters(): string {
        return JSON.stringify(this.filtersList);
    }
}

export class Attachment implements EmailAttachment {

    static availableTypes = [
        '.txt', '.pdf', '.doc', 'docx', '.xls', 'xlsx', '.ppt', 'pptx',
        '.bmp', '.gif', '.ico', 'jpeg', '.pcx', '.png', 'tiff', '.jpg',
        '.mp4', '.avi',
    ];

    type: string;

    public static isNotAvailableType(path: string): boolean {
        const type = path ? path.toLowerCase().slice(-4) : null;
        return Attachment.availableTypes.indexOf(type) === -1;
    }

    constructor(
        public name:     string = '',
        public fileSize: number = 0,
        public path:     string = '',
    ) {
        this.type = this.path ? this.path.toLowerCase().slice(-4) : null;
    }

    isImage() {
        return ['.gif', 'jpeg', '.png', '.jpg'].indexOf(this.type) !== -1;
    }

    isNeedViewer() {
        return ['.txt', '.pdf', '.doc', 'docx', '.xls', 'xlsx', '.ppt', 'pptx'].indexOf(this.type) !== -1;
    }

    openViewer() {
        const _src = `https://docs.google.com/viewer?url=${this.path}&embedded=true`;
        window.open(_src);
    }

    downloadAttachment() {
        window.open(this.path);
    }

}

export class ResidentEmailRecipient {
    constructor(
        public id:                number = null,
        public email:             string = '',
        public fullName:          string = '',
        public groups:            Array<any> = [],
        public phones:            Array<any> = [],
        public role:              ResidentRoleType = 'unknown',
        public emailWaiverSigned: boolean = false,
        public buildingId:        number = null,
        public buildingName:      string = '',
        public buildingAddress:   string = '',
        public suiteId:           string = null,
        public suiteNumber:       string = '',
        public commonElementsFee: string = '',

        public checked: boolean = false,
    ) {}
}

export class RecipientMailingResult {
    constructor(
        public id:           string = '',
        public suiteName:    string = '',
        public buildingName: string = '',
        public name:         string = '',
        public type:         string = '',
        public email:        string = '',
        public status:       string = '',
    ) {}

    humanReadableType() {
        return recipientMailingListType[this.type] || 'unknown';
    }
}

export class ResidentInbox {
    constructor(
        public id:              string = '',
        public subject:         string = '',
        public readAt:          number = null,
        public recipientSuite:  string = '',
        public createdAt:       string = ''
    ) {}
}





// WEBPACK FOOTER //
// /app/src/app/types/email-data.types.ts